import React from "react";
import Dialog from "@mui/material/Dialog";
import {Boat} from "../../schemas/boats/boatsSchema";
import BoatCreate from "../../pages/boats/BoatCreate";

interface BoatCreateDialogProps {
    open: boolean;
    onClose: () => void;
    onSuccess: (boat: Boat) => void;
}

const BoatCreateDialog: React.FC<BoatCreateDialogProps> = ({ open, onClose, onSuccess }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md">
            <BoatCreate
                mode="dialog"
                onSuccess={onSuccess}
                onCancel={onClose}
            />
        </Dialog>
    );
};

export default BoatCreateDialog;
